import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
import(/* webpackMode: "eager" */ "/vercel/path0/src/component/form/NewsletterForm2.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/src/component/header/HeaderSection4.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/src/component/main/ProductDetailMain.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/src/component/modal/VideoModal.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/src/component/shop/ShopCard.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/src/component/utils/DivAnimateYAxis.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/src/component/video/VideoSection2.tsx")